import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { IntentBehaviorProvider } from 'seagull';
import { useStore } from '~/contexts';
import { selectors } from '~/store/state-selectors';
export default function SeagullIntentBehaviorProvider(props) {
    const { getIntentBehavior, children } = props;
    const userRole = useStore(selectors.user.role);
    const intentBehavior = useMemo(()=>_object_spread({}, getIntentBehavior(userRole)), [
        userRole,
        getIntentBehavior
    ]);
    return /*#__PURE__*/ _jsx(IntentBehaviorProvider, {
        value: intentBehavior,
        children: children
    });
}
